<script setup>
  import {inject, ref} from "vue";

  import {router} from "@inertiajs/vue3";
  import {MedCheckbox, MedFormField, MedLabel} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentDoNotShowAgain",
  });

  const props = defineProps({
    settingsName: {
      type: String,
      required: true,
    },
  });

  const privacy = inject("$privacy");

  const checked = ref(false);

  const toggleSetting = () => {
    router.post(
      route("settings.store", {user: privacy.getCurrentUser()?.id}),
      {
        [props.settingsName]: !checked.value,
      },
      {
        preserveState: true,
        preserveScroll: true,
        only: ["flash", "client"],
      },
    );
  };
</script>

<template>
  <MedFormField orientation="horizontal">
    <MedCheckbox
      v-model="checked"
      variant="primary"
      :data-test="getTestId('do-not-show-again-checkbox')"
      @update:model-value="toggleSetting()"
    />

    <MedLabel>
      <slot>Nicht mehr anzeigen</slot>
    </MedLabel>
  </MedFormField>
</template>
